import { AVATAR_SIZES } from './consts'
import styles from './index.module.scss'

export function Avatar({ url, size = AVATAR_SIZES.md, alt = '' }) {
  return <img alt={alt} className={`${styles.avatar} ${styles[size]}`} src={url} />
}
